import { useGetWebsiteContributors } from '@va/dashboard/api-client/contributors.api';
import { useConversionAuthors } from '@va/dashboard/shared/conversions';
import { useTranslate } from '@va/localization';
import { SingleSelectFilter } from '@va/shared/feature-filters';
import { useMemo } from 'react';

export const useConversionsAuthorFilter = () => {
  const { data: authorIds, isLoading: isLoadingAuthors } = useConversionAuthors();
  const { data: contributorsData, isLoading: isLoadingContributors } = useGetWebsiteContributors();
  const translate = useTranslate();

  const authors = useMemo(() => {
    if (isLoadingAuthors || isLoadingContributors) return [];
    if (!authorIds?.length || !contributorsData) {
      return [];
    }
    const authorsSet = new Set(authorIds);
    const { owner, contributors } = contributorsData;

    const result = [];

    if (authorsSet.has(owner.id)) {
      result.push({ label: owner.fullName || owner.email, value: owner.id });
    }

    result.push(
      ...contributors
        .filter((c) => authorsSet.has(c.id))
        .map((c) => ({
          label: c.fullName || c.email,
          value: c.id,
        })),
    );

    return result;
  }, [authorIds, contributorsData, isLoadingAuthors, isLoadingContributors]);

  return useMemo(
    () =>
      new SingleSelectFilter({
        id: 'createdBy',
        name: 'createdBy',
        label: translate('all.filters.author'),
        appliedLabel: translate('filters.applied.author'),
        inputProps: {
          label: translate('filters.placeholder.author'),
          useOptions: () => ({
            data: authors,
            isLoading: isLoadingAuthors || isLoadingContributors,
          }),
        },
      }),
    [authors, isLoadingAuthors, isLoadingContributors, translate],
  );
};
